import { CSSProperties } from 'preact/compat'

type Props = {
  label: string
  optionStyles?: CSSProperties
}

const STYLES = {
  userSelect: 'none'
}

const OptionsSeparator = (props: Props) => {
  const { label } = props

  return (
    <div key={label} className="wf_reset" role="option" style={STYLES}>
      <div style={props.optionStyles}>{label}</div>
    </div>
  )
}

export default OptionsSeparator
